import { useEffect } from 'react';
import { LocalStorageCache } from '@brighte/passwordless-authenticator';
import StatusMessage from '@components/StatusMessage/StatusMessage';
import { QuoteStatus as Status } from '@graphql/index';
import ApplicationForm from '@pages/ApplicationForm/ApplicationForm';
import { QUOTE_STATUSES, accessibleQuote } from '@utils';

function QuoteStatusPage({ status }: { status: Status | undefined }) {
  useEffect(() => {
    if (status === Status.EXPIRED || status === Status.CANCELLED) {
      const cache = new LocalStorageCache();
      cache.removeAll();
    }
  }, [status]);

  if (!status || accessibleQuote(status)) {
    return <ApplicationForm />;
  }

  const { icon, title, message } = QUOTE_STATUSES[status];

  return <StatusMessage icon={icon} title={title} message={message} />;
}

export default QuoteStatusPage;
